(function() {
  "use strict";
  try {
    if (typeof document != "undefined") {
      var elementStyle = document.createElement("style");
      elementStyle.appendChild(document.createTextNode(".clay-quantity-grid-table-container {\n  width: 100%;\n}\n\n.clay-quantity-grid-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  /* font-size: 13px; */\n  border: 1px solid #242833bf;\n  margin-bottom: 8px;\n  margin-top: 12px;\n}\n\n.clay-quantity-grid-table thead th {\n  border-bottom: 1px solid #242833bf;\n  padding: 8px;\n  text-align: left;\n  font-weight: normal;\n  /* background-color: #f0f0f0; */\n}\n\n.clay-quantity-grid-table tbody td {\n  padding: 8px;\n  border-bottom: 1px solid #242833bf;\n}\n\n.clay-quantity-grid-table tbody tr:last-child td {\n  border-bottom: none;\n}"));
      document.head.appendChild(elementStyle);
    }
  } catch (e) {
    console.error("vite-plugin-css-injected-by-js", e);
  }
})();
!function() {
  "use strict";
  var e, t, r, n, i, o, a, c, l, u, s, p = {}, _ = [], d = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, f = Array.isArray;
  function y(e2, t2) {
    for (var r2 in t2) e2[r2] = t2[r2];
    return e2;
  }
  function m(e2) {
    e2 && e2.parentNode && e2.parentNode.removeChild(e2);
  }
  function h(e2, n2, i2, o2, a2) {
    var c2 = { type: e2, props: n2, key: i2, ref: o2, __k: null, __: null, __b: 0, __e: null, __c: null, constructor: void 0, __v: null == a2 ? ++r : a2, __i: -1, __u: 0 };
    return null == a2 && null != t.vnode && t.vnode(c2), c2;
  }
  function g(e2) {
    return e2.children;
  }
  function v(e2, t2) {
    this.props = e2, this.context = t2;
  }
  function x(e2, t2) {
    if (null == t2) return e2.__ ? x(e2.__, e2.__i + 1) : null;
    for (var r2; t2 < e2.__k.length; t2++) if (null != (r2 = e2.__k[t2]) && null != r2.__e) return r2.__e;
    return "function" == typeof e2.type ? x(e2) : null;
  }
  function P(e2) {
    var t2, r2;
    if (null != (e2 = e2.__) && null != e2.__c) {
      for (e2.__e = e2.__c.base = null, t2 = 0; t2 < e2.__k.length; t2++) if (null != (r2 = e2.__k[t2]) && null != r2.__e) {
        e2.__e = e2.__c.base = r2.__e;
        break;
      }
      return P(e2);
    }
  }
  function b(e2) {
    (!e2.__d && (e2.__d = true) && n.push(e2) && !$.__r++ || i !== t.debounceRendering) && ((i = t.debounceRendering) || o)($);
  }
  function $() {
    for (var e2, r2, i2, o2, c2, l2, u2, s2 = 1; n.length; ) n.length > s2 && n.sort(a), e2 = n.shift(), s2 = n.length, e2.__d && (i2 = void 0, c2 = (o2 = (r2 = e2).__v).__e, l2 = [], u2 = [], r2.__P && ((i2 = y({}, o2)).__v = o2.__v + 1, t.vnode && t.vnode(i2), q(r2.__P, i2, o2, r2.__n, r2.__P.namespaceURI, 32 & o2.__u ? [c2] : null, l2, null == c2 ? x(o2) : c2, !!(32 & o2.__u), u2), i2.__v = o2.__v, i2.__.__k[i2.__i] = i2, R(l2, i2, u2), i2.__e != c2 && P(i2)));
    $.__r = 0;
  }
  function w(e2, t2, r2, n2, i2, o2, a2, c2, l2, u2, s2) {
    var d2, f2, y2, m2, h2, g2, v2 = n2 && n2.__k || _, x2 = t2.length;
    for (l2 = F(r2, t2, v2, l2, x2), d2 = 0; d2 < x2; d2++) null != (y2 = r2.__k[d2]) && (f2 = -1 === y2.__i ? p : v2[y2.__i] || p, y2.__i = d2, g2 = q(e2, y2, f2, i2, o2, a2, c2, l2, u2, s2), m2 = y2.__e, y2.ref && f2.ref != y2.ref && (f2.ref && I(f2.ref, null, y2), s2.push(y2.ref, y2.__c || m2, y2)), null == h2 && null != m2 && (h2 = m2), 4 & y2.__u || f2.__k === y2.__k ? l2 = T(y2, l2, e2) : "function" == typeof y2.type && void 0 !== g2 ? l2 = g2 : m2 && (l2 = m2.nextSibling), y2.__u &= -7);
    return r2.__e = h2, l2;
  }
  function F(e2, t2, r2, n2, i2) {
    var o2, a2, c2, l2, u2, s2 = r2.length, p2 = s2, _2 = 0;
    for (e2.__k = new Array(i2), o2 = 0; o2 < i2; o2++) null != (a2 = t2[o2]) && "boolean" != typeof a2 && "function" != typeof a2 ? (l2 = o2 + _2, (a2 = e2.__k[o2] = "string" == typeof a2 || "number" == typeof a2 || "bigint" == typeof a2 || a2.constructor == String ? h(null, a2, null, null, null) : f(a2) ? h(g, { children: a2 }, null, null, null) : void 0 === a2.constructor && a2.__b > 0 ? h(a2.type, a2.props, a2.key, a2.ref ? a2.ref : null, a2.__v) : a2).__ = e2, a2.__b = e2.__b + 1, c2 = null, -1 !== (u2 = a2.__i = S(a2, r2, l2, p2)) && (p2--, (c2 = r2[u2]) && (c2.__u |= 2)), null == c2 || null === c2.__v ? (-1 == u2 && (i2 > s2 ? _2-- : i2 < s2 && _2++), "function" != typeof a2.type && (a2.__u |= 4)) : u2 != l2 && (u2 == l2 - 1 ? _2-- : u2 == l2 + 1 ? _2++ : (u2 > l2 ? _2-- : _2++, a2.__u |= 4))) : e2.__k[o2] = null;
    if (p2) for (o2 = 0; o2 < s2; o2++) null != (c2 = r2[o2]) && !(2 & c2.__u) && (c2.__e == n2 && (n2 = x(c2)), E(c2, c2));
    return n2;
  }
  function T(e2, t2, r2) {
    var n2, i2;
    if ("function" == typeof e2.type) {
      for (n2 = e2.__k, i2 = 0; n2 && i2 < n2.length; i2++) n2[i2] && (n2[i2].__ = e2, t2 = T(n2[i2], t2, r2));
      return t2;
    }
    e2.__e != t2 && (t2 && e2.type && !r2.contains(t2) && (t2 = x(e2)), r2.insertBefore(e2.__e, t2 || null), t2 = e2.__e);
    do {
      t2 = t2 && t2.nextSibling;
    } while (null != t2 && 8 == t2.nodeType);
    return t2;
  }
  function S(e2, t2, r2, n2) {
    var i2, o2, a2 = e2.key, c2 = e2.type, l2 = t2[r2];
    if (null === l2 && null == e2.key || l2 && a2 == l2.key && c2 === l2.type && !(2 & l2.__u)) return r2;
    if (n2 > (null == l2 || 2 & l2.__u ? 0 : 1)) for (i2 = r2 - 1, o2 = r2 + 1; i2 >= 0 || o2 < t2.length; ) {
      if (i2 >= 0) {
        if ((l2 = t2[i2]) && !(2 & l2.__u) && a2 == l2.key && c2 === l2.type) return i2;
        i2--;
      }
      if (o2 < t2.length) {
        if ((l2 = t2[o2]) && !(2 & l2.__u) && a2 == l2.key && c2 === l2.type) return o2;
        o2++;
      }
    }
    return -1;
  }
  function C(e2, t2, r2) {
    "-" == t2[0] ? e2.setProperty(t2, null == r2 ? "" : r2) : e2[t2] = null == r2 ? "" : "number" != typeof r2 || d.test(t2) ? r2 : r2 + "px";
  }
  function A(e2, t2, r2, n2, i2) {
    var o2;
    e: if ("style" == t2) if ("string" == typeof r2) e2.style.cssText = r2;
    else {
      if ("string" == typeof n2 && (e2.style.cssText = n2 = ""), n2) for (t2 in n2) r2 && t2 in r2 || C(e2.style, t2, "");
      if (r2) for (t2 in r2) n2 && r2[t2] === n2[t2] || C(e2.style, t2, r2[t2]);
    }
    else if ("o" == t2[0] && "n" == t2[1]) o2 = t2 != (t2 = t2.replace(c, "$1")), t2 = t2.toLowerCase() in e2 || "onFocusOut" == t2 || "onFocusIn" == t2 ? t2.toLowerCase().slice(2) : t2.slice(2), e2.l || (e2.l = {}), e2.l[t2 + o2] = r2, r2 ? n2 ? r2.t = n2.t : (r2.t = l, e2.addEventListener(t2, o2 ? s : u, o2)) : e2.removeEventListener(t2, o2 ? s : u, o2);
    else {
      if ("http://www.w3.org/2000/svg" == i2) t2 = t2.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
      else if ("width" != t2 && "height" != t2 && "href" != t2 && "list" != t2 && "form" != t2 && "tabIndex" != t2 && "download" != t2 && "rowSpan" != t2 && "colSpan" != t2 && "role" != t2 && "popover" != t2 && t2 in e2) try {
        e2[t2] = null == r2 ? "" : r2;
        break e;
      } catch (e3) {
      }
      "function" == typeof r2 || (null == r2 || false === r2 && "-" != t2[4] ? e2.removeAttribute(t2) : e2.setAttribute(t2, "popover" == t2 && 1 == r2 ? "" : r2));
    }
  }
  function k(e2) {
    return function(r2) {
      if (this.l) {
        var n2 = this.l[r2.type + e2];
        if (null == r2.u) r2.u = l++;
        else if (r2.u < n2.t) return;
        return n2(t.event ? t.event(r2) : r2);
      }
    };
  }
  function q(e2, r2, n2, i2, o2, a2, c2, l2, u2, s2) {
    var p2, _2, d2, h2, x2, P2, b2, F2, T2, S2, C2, $2, A2, k2, q2, R2, I2, E2 = r2.type;
    if (void 0 !== r2.constructor) return null;
    128 & n2.__u && (u2 = !!(32 & n2.__u), a2 = [l2 = r2.__e = n2.__e]), (p2 = t.__b) && p2(r2);
    e: if ("function" == typeof E2) try {
      if (F2 = r2.props, T2 = "prototype" in E2 && E2.prototype.render, S2 = (p2 = E2.contextType) && i2[p2.__c], C2 = p2 ? S2 ? S2.props.value : p2.__ : i2, n2.__c ? b2 = (_2 = r2.__c = n2.__c).__ = _2.__E : (T2 ? r2.__c = _2 = new E2(F2, C2) : (r2.__c = _2 = new v(F2, C2), _2.constructor = E2, _2.render = D), S2 && S2.sub(_2), _2.props = F2, _2.state || (_2.state = {}), _2.context = C2, _2.__n = i2, d2 = _2.__d = true, _2.__h = [], _2._sb = []), T2 && null == _2.__s && (_2.__s = _2.state), T2 && null != E2.getDerivedStateFromProps && (_2.__s == _2.state && (_2.__s = y({}, _2.__s)), y(_2.__s, E2.getDerivedStateFromProps(F2, _2.__s))), h2 = _2.props, x2 = _2.state, _2.__v = r2, d2) T2 && null == E2.getDerivedStateFromProps && null != _2.componentWillMount && _2.componentWillMount(), T2 && null != _2.componentDidMount && _2.__h.push(_2.componentDidMount);
      else {
        if (T2 && null == E2.getDerivedStateFromProps && F2 !== h2 && null != _2.componentWillReceiveProps && _2.componentWillReceiveProps(F2, C2), !_2.__e && (null != _2.shouldComponentUpdate && false === _2.shouldComponentUpdate(F2, _2.__s, C2) || r2.__v == n2.__v)) {
          for (r2.__v != n2.__v && (_2.props = F2, _2.state = _2.__s, _2.__d = false), r2.__e = n2.__e, r2.__k = n2.__k, r2.__k.some(function(e3) {
            e3 && (e3.__ = r2);
          }), $2 = 0; $2 < _2._sb.length; $2++) _2.__h.push(_2._sb[$2]);
          _2._sb = [], _2.__h.length && c2.push(_2);
          break e;
        }
        null != _2.componentWillUpdate && _2.componentWillUpdate(F2, _2.__s, C2), T2 && null != _2.componentDidUpdate && _2.__h.push(function() {
          _2.componentDidUpdate(h2, x2, P2);
        });
      }
      if (_2.context = C2, _2.props = F2, _2.__P = e2, _2.__e = false, A2 = t.__r, k2 = 0, T2) {
        for (_2.state = _2.__s, _2.__d = false, A2 && A2(r2), p2 = _2.render(_2.props, _2.state, _2.context), q2 = 0; q2 < _2._sb.length; q2++) _2.__h.push(_2._sb[q2]);
        _2._sb = [];
      } else do {
        _2.__d = false, A2 && A2(r2), p2 = _2.render(_2.props, _2.state, _2.context), _2.state = _2.__s;
      } while (_2.__d && ++k2 < 25);
      _2.state = _2.__s, null != _2.getChildContext && (i2 = y(y({}, i2), _2.getChildContext())), T2 && !d2 && null != _2.getSnapshotBeforeUpdate && (P2 = _2.getSnapshotBeforeUpdate(h2, x2)), R2 = p2, null != p2 && p2.type === g && null == p2.key && (R2 = L(p2.props.children)), l2 = w(e2, f(R2) ? R2 : [R2], r2, n2, i2, o2, a2, c2, l2, u2, s2), _2.base = r2.__e, r2.__u &= -161, _2.__h.length && c2.push(_2), b2 && (_2.__E = _2.__ = null);
    } catch (e3) {
      if (r2.__v = null, u2 || null != a2) if (e3.then) {
        for (r2.__u |= u2 ? 160 : 128; l2 && 8 == l2.nodeType && l2.nextSibling; ) l2 = l2.nextSibling;
        a2[a2.indexOf(l2)] = null, r2.__e = l2;
      } else for (I2 = a2.length; I2--; ) m(a2[I2]);
      else r2.__e = n2.__e, r2.__k = n2.__k;
      t.__e(e3, r2, n2);
    }
    else null == a2 && r2.__v == n2.__v ? (r2.__k = n2.__k, r2.__e = n2.__e) : l2 = r2.__e = N(n2.__e, r2, n2, i2, o2, a2, c2, u2, s2);
    return (p2 = t.diffed) && p2(r2), 128 & r2.__u ? void 0 : l2;
  }
  function R(e2, r2, n2) {
    for (var i2 = 0; i2 < n2.length; i2++) I(n2[i2], n2[++i2], n2[++i2]);
    t.__c && t.__c(r2, e2), e2.some(function(r3) {
      try {
        e2 = r3.__h, r3.__h = [], e2.some(function(e3) {
          e3.call(r3);
        });
      } catch (e3) {
        t.__e(e3, r3.__v);
      }
    });
  }
  function L(e2) {
    return "object" != typeof e2 || null == e2 ? e2 : f(e2) ? e2.map(L) : y({}, e2);
  }
  function N(r2, n2, i2, o2, a2, c2, l2, u2, s2) {
    var _2, d2, y2, h2, g2, v2, P2, b2 = i2.props, F2 = n2.props, T2 = n2.type;
    if ("svg" == T2 ? a2 = "http://www.w3.org/2000/svg" : "math" == T2 ? a2 = "http://www.w3.org/1998/Math/MathML" : a2 || (a2 = "http://www.w3.org/1999/xhtml"), null != c2) {
      for (_2 = 0; _2 < c2.length; _2++) if ((g2 = c2[_2]) && "setAttribute" in g2 == !!T2 && (T2 ? g2.localName == T2 : 3 == g2.nodeType)) {
        r2 = g2, c2[_2] = null;
        break;
      }
    }
    if (null == r2) {
      if (null == T2) return document.createTextNode(F2);
      r2 = document.createElementNS(a2, T2, F2.is && F2), u2 && (t.__m && t.__m(n2, c2), u2 = false), c2 = null;
    }
    if (null === T2) b2 === F2 || u2 && r2.data === F2 || (r2.data = F2);
    else {
      if (c2 = c2 && e.call(r2.childNodes), b2 = i2.props || p, !u2 && null != c2) for (b2 = {}, _2 = 0; _2 < r2.attributes.length; _2++) b2[(g2 = r2.attributes[_2]).name] = g2.value;
      for (_2 in b2) if (g2 = b2[_2], "children" == _2) ;
      else if ("dangerouslySetInnerHTML" == _2) y2 = g2;
      else if (!(_2 in F2)) {
        if ("value" == _2 && "defaultValue" in F2 || "checked" == _2 && "defaultChecked" in F2) continue;
        A(r2, _2, null, g2, a2);
      }
      for (_2 in F2) g2 = F2[_2], "children" == _2 ? h2 = g2 : "dangerouslySetInnerHTML" == _2 ? d2 = g2 : "value" == _2 ? v2 = g2 : "checked" == _2 ? P2 = g2 : u2 && "function" != typeof g2 || b2[_2] === g2 || A(r2, _2, g2, b2[_2], a2);
      if (d2) u2 || y2 && (d2.__html === y2.__html || d2.__html === r2.innerHTML) || (r2.innerHTML = d2.__html), n2.__k = [];
      else if (y2 && (r2.innerHTML = ""), w("template" === n2.type ? r2.content : r2, f(h2) ? h2 : [h2], n2, i2, o2, "foreignObject" == T2 ? "http://www.w3.org/1999/xhtml" : a2, c2, l2, c2 ? c2[0] : i2.__k && x(i2, 0), u2, s2), null != c2) for (_2 = c2.length; _2--; ) m(c2[_2]);
      u2 || (_2 = "value", "progress" == T2 && null == v2 ? r2.removeAttribute("value") : void 0 !== v2 && (v2 !== r2[_2] || "progress" == T2 && !v2 || "option" == T2 && v2 !== b2[_2]) && A(r2, _2, v2, b2[_2], a2), _2 = "checked", void 0 !== P2 && P2 !== r2[_2] && A(r2, _2, P2, b2[_2], a2));
    }
    return r2;
  }
  function I(e2, r2, n2) {
    try {
      if ("function" == typeof e2) {
        var i2 = "function" == typeof e2.__u;
        i2 && e2.__u(), i2 && null == r2 || (e2.__u = e2(r2));
      } else e2.current = r2;
    } catch (e3) {
      t.__e(e3, n2);
    }
  }
  function E(e2, r2, n2) {
    var i2, o2;
    if (t.unmount && t.unmount(e2), (i2 = e2.ref) && (i2.current && i2.current !== e2.__e || I(i2, null, r2)), null != (i2 = e2.__c)) {
      if (i2.componentWillUnmount) try {
        i2.componentWillUnmount();
      } catch (e3) {
        t.__e(e3, r2);
      }
      i2.base = i2.__P = null;
    }
    if (i2 = e2.__k) for (o2 = 0; o2 < i2.length; o2++) i2[o2] && E(i2[o2], r2, n2 || "function" != typeof e2.type);
    n2 || m(e2.__e), e2.__c = e2.__ = e2.__e = void 0;
  }
  function D(e2, t2, r2) {
    return this.constructor(e2, r2);
  }
  function j(r2, n2, i2) {
    var o2, a2, c2;
    n2 == document && (n2 = document.documentElement), t.__ && t.__(r2, n2), o2 = false ? null : n2.__k, a2 = [], c2 = [], q(n2, r2 = n2.__k = function(t2, r3, n3) {
      var i3, o3, a3, c3 = {};
      for (a3 in r3) "key" == a3 ? i3 = r3[a3] : "ref" == a3 ? o3 = r3[a3] : c3[a3] = r3[a3];
      if (arguments.length > 2 && (c3.children = arguments.length > 3 ? e.call(arguments, 2) : n3), "function" == typeof t2 && null != t2.defaultProps) for (a3 in t2.defaultProps) void 0 === c3[a3] && (c3[a3] = t2.defaultProps[a3]);
      return h(t2, c3, i3, o3, null);
    }(g, null, [r2]), o2 || p, p, n2.namespaceURI, o2 ? null : n2.firstChild ? e.call(n2.childNodes) : null, a2, o2 ? o2.__e : n2.firstChild, false, c2), R(a2, r2, c2);
  }
  e = _.slice, t = { __e: function(e2, t2, r2, n2) {
    for (var i2, o2, a2; t2 = t2.__; ) if ((i2 = t2.__c) && !i2.__) try {
      if ((o2 = i2.constructor) && null != o2.getDerivedStateFromError && (i2.setState(o2.getDerivedStateFromError(e2)), a2 = i2.__d), null != i2.componentDidCatch && (i2.componentDidCatch(e2, n2 || {}), a2 = i2.__d), a2) return i2.__E = i2;
    } catch (t3) {
      e2 = t3;
    }
    throw e2;
  } }, r = 0, v.prototype.setState = function(e2, t2) {
    var r2;
    r2 = null != this.__s && this.__s !== this.state ? this.__s : this.__s = y({}, this.state), "function" == typeof e2 && (e2 = e2(y({}, r2), this.props)), e2 && y(r2, e2), null != e2 && this.__v && (t2 && this._sb.push(t2), b(this));
  }, v.prototype.forceUpdate = function(e2) {
    this.__v && (this.__e = true, e2 && this.__h.push(e2), b(this));
  }, v.prototype.render = g, n = [], o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, a = function(e2, t2) {
    return e2.__v.__b - t2.__v.__b;
  }, $.__r = 0, c = /(PointerCapture)$|Capture$/i, l = 0, u = k(false), s = k(true);
  var O = 0;
  function U(e2, r2, n2, i2, o2, a2) {
    r2 || (r2 = {});
    var c2, l2, u2 = r2;
    if ("ref" in u2) for (l2 in u2 = {}, r2) "ref" == l2 ? c2 = r2[l2] : u2[l2] = r2[l2];
    var s2 = { type: e2, props: u2, key: n2, ref: c2, __k: null, __: null, __b: 0, __e: null, __c: null, constructor: void 0, __v: --O, __i: -1, __u: 0, __source: o2, __self: a2 };
    if ("function" == typeof e2 && (c2 = e2.defaultProps)) for (l2 in c2) void 0 === u2[l2] && (u2[l2] = c2[l2]);
    return t.vnode && t.vnode(s2), s2;
  }
  const M = /* @__PURE__ */ new Map(), H = (e2) => Date.now() - e2 > 3e5, G = async ({ shopDomain: e2, accessToken: t2, query: r2, variables: n2 }) => {
    try {
      const i2 = `https://${e2}/api/2024-07/graphql.json`, o2 = { "X-Shopify-Storefront-Access-Token": t2, "Content-Type": "application/json" }, a2 = await fetch(i2, { method: "POST", headers: o2, body: JSON.stringify({ query: r2, variables: n2 }) });
      return await a2.json();
    } catch (e3) {
      throw console.log("error", e3), e3;
    }
  }, W = async (e2, t2, r2, n2, i2, o2) => {
    var _a, _b, _c, _d, _e2, _f, _g, _h, _i, _j, _k, _l;
    const a2 = ((e3, t3, r3, n3, i3) => `${e3}:${t3}:${r3}:${JSON.stringify(n3)}:${i3}`)(e2, r2, n2, i2, o2), c2 = M.get(a2);
    if (c2 && !H(c2.timestamp)) return c2.data;
    try {
      let c3, l2 = true, u2 = [];
      for (; l2; ) {
        const a3 = await G({ shopDomain: e2, accessToken: t2, query: `query fetchProductVariantMetafield($handle: String!, $country: CountryCode) @inContext(country: $country){
                    product(handle: $handle) {
                        title
                        handle
                        variants(first: 250,after: ${c3 ? `"${c3}"` : "null"}){
                            edges{
                                node{
                                    id
                                    title
                                    metafield(namespace: "app--173437812737--clay", key: "pricing_rule"){
                                        value
                                        type
                                    }
                                    price{
                                      amount
                                      currencyCode
                                    }
                                    compareAtPrice{
                                      amount
                                      currencyCode
                                    }
                                }
                            }
                            pageInfo{
                                hasNextPage
                                endCursor
                            }
                        }
                    }
                }`, variables: { handle: r2, country: o2 } });
        if (!((_a = a3.data) == null ? void 0 : _a.product)) return l2 = false, console.log("No products found"), [];
        const s3 = (_d = (_c = (_b = a3.data) == null ? void 0 : _b.product) == null ? void 0 : _c.variants) == null ? void 0 : _d.edges.map((e3) => {
          var _a2;
          const t3 = e3.node, r3 = t3.id.split("/").pop(), o3 = (_a2 = t3.metafield) == null ? void 0 : _a2.value, a4 = B("string" == typeof o3 ? JSON.parse(o3) : []);
          let c4 = a4.find((e4) => e4.customerGroupId === n2 && !["LOGGED_IN", "ALL"].includes(n2) || i2.includes(e4.customerTag));
          c4 || "ALL" === n2 || (c4 = a4.find((e4) => "LOGGED_IN" === e4.customerGroupId)), c4 || "ALL" !== n2 || (c4 = a4.find((e4) => "ALL" === e4.customerGroupId));
          const l3 = window.clayMarketHandle;
          window.clayCountryCurrency;
          if (c4) {
            let e4 = c4.markets.find((e5) => e5.handle === l3 || "" === e5.handle) || null;
            if (e4) {
              const n3 = { ...c4, markets: [e4] };
              if ("" === n3.ownerId || n3.ownerId === r3.split("/").pop()) return { id: r3, title: t3.title, pricingRule: n3, price: t3.price, compareAtPrice: t3.compareAtPrice };
            }
          }
          return { id: r3, title: t3.title, pricingRule: null, price: t3.price, compareAtPrice: t3.compareAtPrice };
        });
        u2.push(...s3), l2 = (_h = (_g = (_f = (_e2 = a3.data) == null ? void 0 : _e2.product) == null ? void 0 : _f.variants) == null ? void 0 : _g.pageInfo) == null ? void 0 : _h.hasNextPage, c3 = (_l = (_k = (_j = (_i = a3.data) == null ? void 0 : _i.product) == null ? void 0 : _j.variants) == null ? void 0 : _k.pageInfo) == null ? void 0 : _l.endCursor;
      }
      const s2 = { handle: r2, allVariants: u2 };
      return M.set(a2, { data: s2, timestamp: Date.now() }), Q(), s2;
    } catch (e3) {
      throw console.error("Error fetching product metafield:", e3), e3;
    }
  };
  function B(e2) {
    if (!Array.isArray(e2) || 0 === e2.length) return [];
    const t2 = e2[0];
    return "customerGroupId" in t2 ? (r2 = e2, Array.isArray(r2) ? r2.map((e3 = {}) => {
      const { customerGroupId: t3 = "", customerTag: r3 = "", type: n2 = "WHOLESALE", wholesalePrice: i2 = null, quantityPrice: o2 = {} } = e3;
      let a2 = false;
      "QUANTITY" === n2 && (a2 = !!o2.isVariantUnique);
      let c2 = [];
      return "WHOLESALE" === n2 && null != i2 ? c2.push({ quantity: "1", price: i2 }) : Array.isArray(o2.value) && (c2 = o2.value), { ownerId: "", customerGroupId: t3, customerTag: r3, markets: [{ handle: "", currency: "", pricing: { type: c2.length > 1 ? "QUANTITY" : "WHOLESALE", strategy: "A", isVariantUnique: a2, priceSource: "R", values: c2 } }] };
    }) : []) : "i" in t2 ? function(e3) {
      if (!e3 || !Array.isArray(e3)) return null;
      return e3.map((e4 = {}) => {
        let t3 = e4.o || "", [r3 = "", n2 = ""] = (e4.i || "").split("~");
        return { ownerId: t3, customerGroupId: r3, customerTag: n2, markets: e4.p.split("|").map((e5) => {
          let [t4 = "", r4 = "", n3 = "A", i2 = "0", o2 = "R", a2 = ""] = e5.split("~"), c2 = a2.split(";").map((e6) => {
            let [t5 = "1", r5 = "0"] = e6.split(":");
            return { quantity: t5, price: r5 };
          }) ?? [];
          return { handle: t4, currency: r4, pricing: { type: c2.length > 1 ? "QUANTITY" : "WHOLESALE", strategy: n3, priceSource: o2, isVariantUnique: "1" === i2, values: c2 } };
        }) };
      });
    }(e2) : [];
    var r2;
  }
  const Q = () => {
    for (const [e2, t2] of M.entries()) H(t2.timestamp) && M.delete(e2);
  };
  function V(e2, t2) {
    if (null === e2) return "";
    const r2 = "string" == typeof e2 ? parseFloat(e2) : e2, n2 = r2.toFixed(2), i2 = r2.toFixed(0), o2 = n2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), a2 = i2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return t2.replace("{{amount}}", n2).replace("{{amount_no_decimals}}", i2).replace("{{amount_with_comma_separator}}", o2).replace("{{amount_no_decimals_with_comma_separator}}", a2);
  }
  function Y(e2, t2, r2) {
    var _a;
    let n2 = "", i2 = "", o2 = "", a2 = "", c2 = ((_a = e2.pricingRule) == null ? void 0 : _a.markets[0]) ?? null;
    if (!c2) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
    let l2 = c2.pricing.type;
    return "QUANTITY" === l2 ? { retailPriceText: n2, compareAtPriceText: i2, savingsText: o2, maxRetailPriceText: a2 } = function(e3, t3, r3, n3) {
      let i3 = n3.pricing.strategy, o3 = n3.pricing.values, a3 = n3.currency, c3 = e3.price.currencyCode, l3 = "R" === n3.pricing.priceSource ? e3.price.amount : "C" === n3.pricing.priceSource ? e3.compareAtPrice.amount : e3.price.amount, u2 = window.marketConversionRate;
      if (!l3 || "" === l3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      let s2 = o3.filter((e4) => Number(e4.quantity) <= r3).reduce((e4, t4) => Number(t4.quantity) > Number(e4.quantity) ? t4 : e4, { price: "0", quantity: "0" }).price;
      if (a3 !== c3 && "" !== a3) {
        if (!u2 || !u2.conversion_rate) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
        ["A", "F"].includes(i3) && (s2 = (parseFloat(s2) * u2.conversion_rate).toFixed(2).toString());
      }
      let p2 = "A" === i3 ? s2 : "P" === i3 ? (parseFloat(l3) * (1 - parseFloat(s2) / 100)).toFixed(2).toString() : "F" === i3 ? (parseFloat(l3) - parseFloat(s2)).toFixed(2).toString() : e3.price.amount;
      if ("" === a3 && u2 && u2.base_currency !== c3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      (parseFloat(p2) < 0 || parseFloat(p2) > parseFloat(e3.price.amount)) && (p2 = e3.price.amount);
      let _2 = V(p2, clayProductPriceConfig.priceDisplayText), d2 = V(l3, clayProductPriceConfig.compareAtPriceDisplayText), f2 = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(l3) - parseFloat(p2)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(l3) - parseFloat(p2)) / parseFloat(l3) * 100).toFixed(0) : 0, y2 = V(f2, clayProductPriceConfig.savingsDisplayText);
      return u2 && (_2 = window.clayCurrencySymbol + parseFloat(p2).toFixed(2) + " " + window.clayCountryCurrency, d2 = window.clayCurrencySymbol + parseFloat(l3).toFixed(2) + " " + window.clayCountryCurrency, y2 = "Save " + ("amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? window.clayCurrencySymbol + f2 + " " + window.clayCountryCurrency : "percentage" === clayProductPriceConfig.savingsDisplayType ? f2 + "%" : "")), { retailPriceText: _2, compareAtPriceText: d2, savingsText: y2, maxRetailPriceText: "" };
    }(e2, 0, r2, c2) : "WHOLESALE" === l2 && ({ retailPriceText: n2, compareAtPriceText: i2, savingsText: o2, maxRetailPriceText: a2 } = function(e3, t3, r3) {
      let n3 = r3.pricing.strategy;
      r3.pricing.values;
      let i3 = r3.currency, o3 = e3.price.currencyCode, a3 = window.marketConversionRate, c3 = "R" === r3.pricing.priceSource ? e3.price.amount : "C" === r3.pricing.priceSource ? e3.compareAtPrice.amount : e3.price.amount, l3 = r3.pricing.values[0].price;
      if (!c3 || "" === c3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      if (i3 !== o3 && "" !== i3) {
        if (!a3 || !a3.conversion_rate) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
        ["A", "F"].includes(n3) && (l3 = (parseFloat(l3) * a3.conversion_rate).toFixed(2).toString());
      }
      let u2 = "A" === n3 ? l3 : "P" === n3 ? (parseFloat(c3) * (1 - parseFloat(l3) / 100)).toFixed(2).toString() : "F" === n3 ? (parseFloat(c3) - parseFloat(l3)).toFixed(2).toString() : e3.price.amount;
      if ("" === i3 && a3 && a3.base_currency !== o3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      (parseFloat(u2) < 0 || parseFloat(u2) > parseFloat(e3.price.amount)) && (u2 = e3.price.amount);
      let s2 = V(u2, clayProductPriceConfig.priceDisplayText), p2 = V(c3, clayProductPriceConfig.compareAtPriceDisplayText), _2 = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(c3) - parseFloat(u2)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(c3) - parseFloat(u2)) / parseFloat(c3) * 100).toFixed(0) : 0, d2 = V(_2, clayProductPriceConfig.savingsDisplayText);
      return a3 && (s2 = window.clayCurrencySymbol + parseFloat(u2).toFixed(2) + " " + window.clayCountryCurrency, p2 = window.clayCurrencySymbol + parseFloat(c3).toFixed(2) + " " + window.clayCountryCurrency, d2 = "Save " + ("amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? window.clayCurrencySymbol + _2 + " " + window.clayCountryCurrency : "percentage" === clayProductPriceConfig.savingsDisplayType ? _2 + "%" : "")), { retailPriceText: s2, compareAtPriceText: p2, savingsText: d2, maxRetailPriceText: "" };
    }(e2, 0, c2)), { retailPriceText: n2, compareAtPriceText: i2, savingsText: o2, maxRetailPriceText: a2 };
  }
  function J(e2) {
    if (!e2 || "" === e2) return null;
    let t2 = null;
    const r2 = e2.match(/\/products\/([^/?#]+)/);
    return r2 && r2[1] && (t2 = decodeURIComponent(r2[1])), t2;
  }
  async function z(e2) {
    const t2 = window.clayStorefrontConfig || {}, r2 = window.clayCustomerTier || {}, n2 = window.clayCustomerTags || [], i2 = window.clayCountryIsoCode, { allVariants: o2 } = await W(t2.shopDomain, t2.token, e2, "" === r2.customerGroupId ? "LOGGED_IN" : r2.customerGroupId, n2, i2);
    return o2;
  }
  const K = "%[a-f0-9]{2}", X = new RegExp("(" + K + ")|([^%]+?)", "gi"), Z = new RegExp("(" + K + ")+", "gi");
  function ee(e2, t2) {
    try {
      return [decodeURIComponent(e2.join(""))];
    } catch {
    }
    if (1 === e2.length) return e2;
    t2 = t2 || 1;
    const r2 = e2.slice(0, t2), n2 = e2.slice(t2);
    return Array.prototype.concat.call([], ee(r2), ee(n2));
  }
  function te(e2) {
    try {
      return decodeURIComponent(e2);
    } catch {
      let t2 = e2.match(X) || [];
      for (let r2 = 1; r2 < t2.length; r2++) t2 = (e2 = ee(t2, r2).join("")).match(X) || [];
      return e2;
    }
  }
  function re(e2) {
    if ("string" != typeof e2) throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof e2 + "`");
    try {
      return decodeURIComponent(e2);
    } catch {
      return function(e3) {
        const t2 = { "%FE%FF": "��", "%FF%FE": "��" };
        let r2 = Z.exec(e3);
        for (; r2; ) {
          try {
            t2[r2[0]] = decodeURIComponent(r2[0]);
          } catch {
            const e4 = te(r2[0]);
            e4 !== r2[0] && (t2[r2[0]] = e4);
          }
          r2 = Z.exec(e3);
        }
        t2["%C2"] = "�";
        const n2 = Object.keys(t2);
        for (const r3 of n2) e3 = e3.replace(new RegExp(r3, "g"), t2[r3]);
        return e3;
      }(e2);
    }
  }
  function ne(e2, t2) {
    const r2 = {};
    if (Array.isArray(t2)) for (const n2 of t2) {
      const t3 = Object.getOwnPropertyDescriptor(e2, n2);
      (t3 == null ? void 0 : t3.enumerable) && Object.defineProperty(r2, n2, t3);
    }
    else for (const n2 of Reflect.ownKeys(e2)) {
      const i2 = Object.getOwnPropertyDescriptor(e2, n2);
      if (i2.enumerable) {
        t2(n2, e2[n2], e2) && Object.defineProperty(r2, n2, i2);
      }
    }
    return r2;
  }
  function ie(e2, t2) {
    if ("string" != typeof e2 || "string" != typeof t2) throw new TypeError("Expected the arguments to be of type `string`");
    if ("" === e2 || "" === t2) return [];
    const r2 = e2.indexOf(t2);
    return -1 === r2 ? [] : [e2.slice(0, r2), e2.slice(r2 + t2.length)];
  }
  const oe = Symbol("encodeFragmentIdentifier");
  function ae(e2) {
    if ("string" != typeof e2 || 1 !== e2.length) throw new TypeError("arrayFormatSeparator must be single character string");
  }
  function ce(e2, t2) {
    return t2.encode ? t2.strict ? encodeURIComponent(e2).replaceAll(/[!'()*]/g, (e3) => `%${e3.charCodeAt(0).toString(16).toUpperCase()}`) : encodeURIComponent(e2) : e2;
  }
  function le(e2, t2) {
    return t2.decode ? re(e2) : e2;
  }
  function ue(e2) {
    return Array.isArray(e2) ? e2.sort() : "object" == typeof e2 ? ue(Object.keys(e2)).sort((e3, t2) => Number(e3) - Number(t2)).map((t2) => e2[t2]) : e2;
  }
  function se(e2) {
    const t2 = e2.indexOf("#");
    return -1 !== t2 && (e2 = e2.slice(0, t2)), e2;
  }
  function pe(e2, t2, r2) {
    return "string" === r2 && "string" == typeof e2 ? e2 : "function" == typeof r2 && "string" == typeof e2 ? r2(e2) : !t2.parseBooleans || null === e2 || "true" !== e2.toLowerCase() && "false" !== e2.toLowerCase() ? "number" !== r2 || Number.isNaN(Number(e2)) || "string" != typeof e2 || "" === e2.trim() ? t2.parseNumbers && !Number.isNaN(Number(e2)) && "string" == typeof e2 && "" !== e2.trim() ? Number(e2) : e2 : Number(e2) : "true" === e2.toLowerCase();
  }
  function _e(e2) {
    const t2 = (e2 = se(e2)).indexOf("?");
    return -1 === t2 ? "" : e2.slice(t2 + 1);
  }
  function de(e2, t2) {
    ae((t2 = { decode: true, sort: true, arrayFormat: "none", arrayFormatSeparator: ",", parseNumbers: false, parseBooleans: false, types: /* @__PURE__ */ Object.create(null), ...t2 }).arrayFormatSeparator);
    const r2 = function(e3) {
      let t3;
      switch (e3.arrayFormat) {
        case "index":
          return (e4, r3, n3) => {
            t3 = /\[(\d*)]$/.exec(e4), e4 = e4.replace(/\[\d*]$/, ""), t3 ? (void 0 === n3[e4] && (n3[e4] = {}), n3[e4][t3[1]] = r3) : n3[e4] = r3;
          };
        case "bracket":
          return (e4, r3, n3) => {
            t3 = /(\[])$/.exec(e4), e4 = e4.replace(/\[]$/, ""), t3 ? void 0 !== n3[e4] ? n3[e4] = [...n3[e4], r3] : n3[e4] = [r3] : n3[e4] = r3;
          };
        case "colon-list-separator":
          return (e4, r3, n3) => {
            t3 = /(:list)$/.exec(e4), e4 = e4.replace(/:list$/, ""), t3 ? void 0 !== n3[e4] ? n3[e4] = [...n3[e4], r3] : n3[e4] = [r3] : n3[e4] = r3;
          };
        case "comma":
        case "separator":
          return (t4, r3, n3) => {
            const i2 = "string" == typeof r3 && r3.includes(e3.arrayFormatSeparator), o2 = "string" == typeof r3 && !i2 && le(r3, e3).includes(e3.arrayFormatSeparator);
            r3 = o2 ? le(r3, e3) : r3;
            const a2 = i2 || o2 ? r3.split(e3.arrayFormatSeparator).map((t5) => le(t5, e3)) : null === r3 ? r3 : le(r3, e3);
            n3[t4] = a2;
          };
        case "bracket-separator":
          return (t4, r3, n3) => {
            const i2 = /(\[])$/.test(t4);
            if (t4 = t4.replace(/\[]$/, ""), !i2) return void (n3[t4] = r3 ? le(r3, e3) : r3);
            const o2 = null === r3 ? [] : le(r3, e3).split(e3.arrayFormatSeparator);
            void 0 !== n3[t4] ? n3[t4] = [...n3[t4], ...o2] : n3[t4] = o2;
          };
        default:
          return (e4, t4, r3) => {
            void 0 !== r3[e4] ? r3[e4] = [...[r3[e4]].flat(), t4] : r3[e4] = t4;
          };
      }
    }(t2), n2 = /* @__PURE__ */ Object.create(null);
    if ("string" != typeof e2) return n2;
    if (!(e2 = e2.trim().replace(/^[?#&]/, ""))) return n2;
    for (const i2 of e2.split("&")) {
      if ("" === i2) continue;
      const e3 = t2.decode ? i2.replaceAll("+", " ") : i2;
      let [o2, a2] = ie(e3, "=");
      void 0 === o2 && (o2 = e3), a2 = void 0 === a2 ? null : ["comma", "separator", "bracket-separator"].includes(t2.arrayFormat) ? a2 : le(a2, t2), r2(le(o2, t2), a2, n2);
    }
    for (const [e3, r3] of Object.entries(n2)) if ("object" == typeof r3 && null !== r3 && "string" !== t2.types[e3]) for (const [n3, i2] of Object.entries(r3)) {
      const o2 = t2.types[e3] ? t2.types[e3].replace("[]", "") : void 0;
      r3[n3] = pe(i2, t2, o2);
    }
    else "object" == typeof r3 && null !== r3 && "string" === t2.types[e3] ? n2[e3] = Object.values(r3).join(t2.arrayFormatSeparator) : n2[e3] = pe(r3, t2, t2.types[e3]);
    return false === t2.sort ? n2 : (true === t2.sort ? Object.keys(n2).sort() : Object.keys(n2).sort(t2.sort)).reduce((e3, t3) => {
      const r3 = n2[t3];
      return e3[t3] = Boolean(r3) && "object" == typeof r3 && !Array.isArray(r3) ? ue(r3) : r3, e3;
    }, /* @__PURE__ */ Object.create(null));
  }
  function fe(e2, t2) {
    if (!e2) return "";
    ae((t2 = { encode: true, strict: true, arrayFormat: "none", arrayFormatSeparator: ",", ...t2 }).arrayFormatSeparator);
    const r2 = (r3) => t2.skipNull && null == e2[r3] || t2.skipEmptyString && "" === e2[r3], n2 = function(e3) {
      switch (e3.arrayFormat) {
        case "index":
          return (t3) => (r3, n3) => {
            const i3 = r3.length;
            return void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? r3 : null === n3 ? [...r3, [ce(t3, e3), "[", i3, "]"].join("")] : [...r3, [ce(t3, e3), "[", ce(i3, e3), "]=", ce(n3, e3)].join("")];
          };
        case "bracket":
          return (t3) => (r3, n3) => void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? r3 : null === n3 ? [...r3, [ce(t3, e3), "[]"].join("")] : [...r3, [ce(t3, e3), "[]=", ce(n3, e3)].join("")];
        case "colon-list-separator":
          return (t3) => (r3, n3) => void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? r3 : null === n3 ? [...r3, [ce(t3, e3), ":list="].join("")] : [...r3, [ce(t3, e3), ":list=", ce(n3, e3)].join("")];
        case "comma":
        case "separator":
        case "bracket-separator": {
          const t3 = "bracket-separator" === e3.arrayFormat ? "[]=" : "=";
          return (r3) => (n3, i3) => void 0 === i3 || e3.skipNull && null === i3 || e3.skipEmptyString && "" === i3 ? n3 : (i3 = null === i3 ? "" : i3, 0 === n3.length ? [[ce(r3, e3), t3, ce(i3, e3)].join("")] : [[n3, ce(i3, e3)].join(e3.arrayFormatSeparator)]);
        }
        default:
          return (t3) => (r3, n3) => void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? r3 : null === n3 ? [...r3, ce(t3, e3)] : [...r3, [ce(t3, e3), "=", ce(n3, e3)].join("")];
      }
    }(t2), i2 = {};
    for (const [t3, n3] of Object.entries(e2)) r2(t3) || (i2[t3] = n3);
    const o2 = Object.keys(i2);
    return false !== t2.sort && o2.sort(t2.sort), o2.map((r3) => {
      const i3 = e2[r3];
      return void 0 === i3 ? "" : null === i3 ? ce(r3, t2) : Array.isArray(i3) ? 0 === i3.length && "bracket-separator" === t2.arrayFormat ? ce(r3, t2) + "[]" : i3.reduce(n2(r3), []).join("&") : ce(r3, t2) + "=" + ce(i3, t2);
    }).filter((e3) => e3.length > 0).join("&");
  }
  function ye(e2, t2) {
    var _a;
    t2 = { decode: true, ...t2 };
    let [r2, n2] = ie(e2, "#");
    return void 0 === r2 && (r2 = e2), { url: ((_a = r2 == null ? void 0 : r2.split("?")) == null ? void 0 : _a[0]) ?? "", query: de(_e(e2), t2), ...t2 && t2.parseFragmentIdentifier && n2 ? { fragmentIdentifier: le(n2, t2) } : {} };
  }
  function me(e2, t2) {
    t2 = { encode: true, strict: true, [oe]: true, ...t2 };
    const r2 = se(e2.url).split("?")[0] || "";
    let n2 = fe({ ...de(_e(e2.url), { sort: false }), ...e2.query }, t2);
    n2 && (n2 = `?${n2}`);
    let i2 = function(e3) {
      let t3 = "";
      const r3 = e3.indexOf("#");
      return -1 !== r3 && (t3 = e3.slice(r3)), t3;
    }(e2.url);
    if ("string" == typeof e2.fragmentIdentifier) {
      const n3 = new URL(r2);
      n3.hash = e2.fragmentIdentifier, i2 = t2[oe] ? n3.hash : `#${e2.fragmentIdentifier}`;
    }
    return `${r2}${n2}${i2}`;
  }
  function he(e2, t2, r2) {
    r2 = { parseFragmentIdentifier: true, [oe]: false, ...r2 };
    const { url: n2, query: i2, fragmentIdentifier: o2 } = ye(e2, r2);
    return me({ url: n2, query: ne(i2, t2), fragmentIdentifier: o2 }, r2);
  }
  const ge = Object.freeze(Object.defineProperty({ __proto__: null, exclude: function(e2, t2, r2) {
    return he(e2, Array.isArray(t2) ? (e3) => !t2.includes(e3) : (e3, r3) => !t2(e3, r3), r2);
  }, extract: _e, parse: de, parseUrl: ye, pick: he, stringify: fe, stringifyUrl: me }, Symbol.toStringTag, { value: "Module" }));
  async function ve() {
    let e2 = J(window.location.href);
    if (e2) {
      const t2 = await z(e2), r2 = new URL(window.location.href);
      let n2 = ge.parse(r2.search).variant;
      n2 || (n2 = t2[0].id);
      const i2 = t2.find((e3) => e3.id === n2);
      i2 && async function(e3, t3) {
        var _a;
        const r3 = window.location.href, n3 = new URL(r3), i3 = ge.parse(n3.search);
        let o2 = i3.variant;
        o2 || (o2 = t3[0].id);
        const a2 = t3.find((e4) => e4.id === o2), c2 = document.querySelector(".product-info .retail-price"), l2 = document.querySelector(".product-info .compare-at-price");
        if (!c2) return;
        c2.getAttribute("data-variant-id") !== a2.id && c2.setAttribute("data-variant-id", "");
        l2 && l2.getAttribute("data-variant-id") !== a2.id && l2.setAttribute("data-variant-id", "");
        if (!a2.pricingRule) return;
        const { retailPriceText: u2, compareAtPriceText: s2, savingsText: p2, maxRetailPriceText: _2 } = Y(a2, 0, 1);
        if ("" === u2) return;
        c2.innerHTML !== u2 && !c2.classList.contains("clay-wholesale-price") || (c2.getAttribute("data-variant-id"), a2.id), c2.innerHTML = u2, c2.classList.add("clay-wholesale-price"), c2.setAttribute("data-variant-id", a2.id), (l2 && l2.innerHTML !== s2 && !l2.classList.contains("clay-wholesale-price") || l2 && l2.getAttribute("data-variant-id") !== a2.id) && (l2.innerHTML = s2, l2.classList.add("clay-wholesale-price"), l2.setAttribute("data-variant-id", a2.id));
        const d2 = c2.parentElement;
        if (u2 !== s2) {
          let e4 = d2.querySelector(".clay-savings-text-container");
          e4 ? (e4.innerHTML = p2, e4.setAttribute("data-variant-id", a2.id)) : (e4 = document.createElement("div"), e4.className = "clay-savings-text-container", e4.innerHTML = p2, e4.setAttribute("data-variant-id", a2.id), d2.appendChild(e4));
        }
        if ("QUANTITY" === a2.pricingRule.markets[0].pricing.type) {
          const e4 = Pe(a2, clayProductPriceConfig.quantityGridTemplate);
          if (!e4) return;
          ((_a = e4[0]) == null ? void 0 : _a.price) && e4.forEach((e5) => {
            let t5 = V(e5.price, clayProductPriceConfig.quantityGridPriceDisplayText);
            window.marketConversionRate && (t5 = V(e5.price, window.clayCurrencySymbol + "{{amount}}")), e5.price = t5;
          });
          let t4 = d2.querySelector(".clay-quantity-grid-table-container");
          t4 && t4.getAttribute("data-variant-id") !== a2.id && t4.remove(), t4 || (t4 = document.createElement("div"), t4.className = "clay-quantity-grid-table-container", d2.appendChild(t4), j(be(e4), t4), t4.setAttribute("data-variant-id", a2.id));
        }
      }(0, t2);
    }
    xe(0, 1e4, 0);
  }
  function xe(e2, t2, r2) {
    let n2 = document.querySelectorAll("product-card");
    n2 = Array.from(n2).filter((e3) => {
      const t3 = e3.querySelector(".retail-price");
      return t3 && !t3.classList.contains("clay-wholesale-price");
    }), n2 && n2.length > 0 && n2.length > r2 && function(e3) {
      e3.forEach(async (e4, t3) => {
        var _a;
        const r3 = (_a = e4.querySelector(".product-card__link")) == null ? void 0 : _a.href;
        if (!r3) return;
        let n3 = J(r3);
        const i2 = e4.querySelector(".retail-price");
        if (!i2 || i2.classList.contains("clay-wholesale-price")) return;
        !async function(e5, t4) {
          e5.sort((e6, t5) => parseFloat(e6.price.amount) - parseFloat(t5.price.amount));
          const r4 = e5[0];
          if (!r4.pricingRule) return;
          const n4 = t4.querySelector(".retail-price"), i3 = t4.querySelector(".compare-at-price"), { retailPriceText: o2, compareAtPriceText: a2, savingsText: c2, maxRetailPriceText: l2 } = Y(r4, 0, 1);
          if ("" === o2) return;
          n4 && n4.innerHTML !== o2 && (n4.innerHTML = o2);
          i3 && i3.innerHTML !== a2 && (i3.innerHTML = a2);
        }(await z(n3), e4);
      });
    }(n2), e2 < t2 && setTimeout(() => {
      xe(e2 + 200, t2, n2.length);
    }, 200);
  }
  !async function() {
    !function() {
      window.addEventListener("popstate", ve);
      const e2 = history.pushState;
      history.pushState = function() {
        e2.apply(this, arguments), ve();
      };
      const t2 = history.replaceState;
      history.replaceState = function() {
        t2.apply(this, arguments), ve();
      }, ve();
    }();
  }();
  const Pe = (e2, t2) => {
    let r2 = e2.pricingRule.markets[0], n2 = r2.pricing.strategy, i2 = r2.pricing.values.map((e3) => ({ ...e3 })), o2 = r2.currency, a2 = e2.price.currencyCode, c2 = "R" === r2.pricing.priceSource ? e2.price.amount : e2.compareAtPrice.amount, l2 = window.marketConversionRate;
    if ("" === o2 && l2 && l2.base_currency !== a2) return null;
    if (!c2 || "" === c2) return null;
    switch (o2 !== a2 && "" !== o2 && l2 && l2.conversion_rate && ["A", "F"].includes(n2) && i2.forEach((e3) => {
      e3.price = (parseFloat(e3.price) * l2.conversion_rate).toFixed(2).toString();
    }), i2.forEach((t3) => {
      let r3 = "A" === n2 ? t3.price : "P" === n2 ? (parseFloat(c2) * (1 - parseFloat(t3.price) / 100)).toFixed(2).toString() : "F" === n2 ? (parseFloat(c2) - parseFloat(t3.price)).toFixed(2).toString() : e2.price.amount;
      (parseFloat(r3) < 0 || parseFloat(r3) > parseFloat(e2.price.amount)) && (r3 = e2.price.amount), t3.price = r3;
    }), t2) {
      case "quantityPrice":
        return i2.map((e3) => ({ quantity: e3.quantity, price: parseFloat(e3.price).toFixed(2) }));
      case "quantityRangePrice":
        return i2.map((e3, t3, r3) => t3 === r3.length - 1 ? { range: `${e3.quantity}+`, price: parseFloat(e3.price).toFixed(2) } : { range: `${e3.quantity}-${r3[t3 + 1].quantity - 1}`, price: parseFloat(e3.price).toFixed(2) });
      case "quantityRangeDiscount":
        return i2.map((e3, t3, r3) => t3 === r3.length - 1 ? { range: `${e3.quantity}+`, discount: ((parseFloat(c2) - parseFloat(e3.price)) / parseFloat(c2) * 100).toFixed(0) + "%" } : { range: `${e3.quantity}-${r3[t3 + 1].quantity - 1}`, discount: ((parseFloat(c2) - parseFloat(e3.price)) / parseFloat(c2) * 100).toFixed(0) + "%" });
      case "quantityBuyPrice":
        return i2.map((e3) => ({ quantity: "Buy " + e3.quantity, price: parseFloat(e3.price).toFixed(2) }));
      case "quantityPriceDiscount":
        return i2.map((e3) => ({ quantity: e3.quantity, price: parseFloat(e3.price).toFixed(2), discount: ((parseFloat(c2) - parseFloat(e3.price)) / parseFloat(c2) * 100).toFixed(0) + "%" }));
      default:
        return [];
    }
  }, be = (e2) => {
    switch (clayProductPriceConfig.quantityGridTemplate) {
      case "quantityPrice":
      case "quantityBuyPrice":
        return U("table", { className: "clay-quantity-grid-table", children: [U("thead", { children: U("tr", { children: [U("th", { children: "Quantity" }), U("th", { children: "Price" })] }) }), U("tbody", { children: e2.map((e3, t2) => U("tr", { children: [U("td", { children: e3.quantity }), U("td", { children: e3.price })] }, t2)) })] });
      case "quantityRangePrice":
        return U("table", { className: "clay-quantity-grid-table", children: [U("thead", { children: U("tr", { children: [U("th", { children: "Quantity Range" }), U("th", { children: "Price" })] }) }), U("tbody", { children: e2.map((e3, t2) => U("tr", { children: [U("td", { children: e3.range }), U("td", { children: e3.price })] }, t2)) })] });
      case "quantityRangeDiscount":
        return U("table", { className: "clay-quantity-grid-table", children: [U("thead", { children: U("tr", { children: [U("th", { children: "Quantity Range" }), U("th", { children: "Discount" })] }) }), U("tbody", { children: e2.map((e3, t2) => U("tr", { children: [U("td", { children: e3.range }), U("td", { children: e3.discount })] }, t2)) })] });
      case "quantityPriceDiscount":
        return U("table", { className: "clay-quantity-grid-table", children: [U("thead", { children: U("tr", { children: [U("th", { children: "Quantity" }), U("th", { children: "Price" }), U("th", { children: "Discount" })] }) }), U("tbody", { children: e2.map((e3, t2) => U("tr", { children: [U("td", { children: e3.quantity }), U("td", { children: e3.price }), U("td", { children: e3.discount })] }, t2)) })] });
      default:
        return null;
    }
  };
}();
